import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { AppProvider, useApp } from "./contexts/AppContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import LogoSVG from "./components/LogoSVG";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import NewsPage from "./pages/NewsPage";
import PostPage from "./pages/PostPage";
import ProjectsPage from "./pages/ProjectsPage";
import ContactPage from "./pages/ContactPage";
import LandownersPage from "./pages/LandownersPage";
import OrgChartPage from "./pages/OrgChartPage";
import NonTeachersUsersPage from "./pages/NonTeachersUsersPage";
import AdminLogin from "./admin/AdminLogin";
import AdminDashboard from "./admin/AdminDashboard";

function Loading() {
  return (
    <div style={{ minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center",
      background:"linear-gradient(135deg,#1a4d28,#2878b5)", color:"#fff", fontFamily:"'Nunito',sans-serif" }}>
      <div style={{ textAlign:"center" }}>
        <LogoSVG size={80} inv/>
        <div style={{ marginTop:"1.5rem", fontSize:"1rem", opacity:.8 }}>Loading LHDA…</div>
      </div>
    </div>
  );
}

function PublicLayout() {
  const { isAdmin, handleLogout, loaded } = useApp();
  if (!loaded) return <Loading/>;
  return (
    <>
      <Navbar isAdmin={isAdmin} onLogout={handleLogout}/>
      <main><Outlet/></main>
      <Footer/>
    </>
  );
}

function AdminLayout() {
  const { isAdmin, handleLogout, loaded } = useApp();
  if (!loaded) return <Loading/>;
  if (!isAdmin) return <Navigate to="/login" replace/>;
  return (
    <>
      <Navbar isAdmin onLogout={handleLogout}/>
      <AdminDashboard onLogout={handleLogout}/>
    </>
  );
}

function LoginLayout() {
  const { isAdmin, loaded } = useApp();
  if (!loaded) return <Loading/>;
  if (isAdmin) return <Navigate to="/admin" replace/>;
  return <Outlet/>;
}

export default function App() {
  return (
    <BrowserRouter>
      <AppProvider>
        <Routes>
          <Route element={<PublicLayout/>}>
            <Route path="/"         element={<HomePage/>}/>
            <Route path="/about"    element={<AboutPage/>}/>
            <Route path="/news"     element={<NewsPage/>}/>
            <Route path="/post/:id" element={<PostPage/>}/>
            <Route path="/projects"   element={<ProjectsPage/>}/>
            <Route path="/landowners" element={<LandownersPage/>}/>
            <Route path="/contact"    element={<ContactPage/>}/>
            <Route path="/non-teachers/:id/orgchart" element={<OrgChartPage/>}/>
            <Route path="/non-teachers/:id/users"    element={<NonTeachersUsersPage/>}/>
          </Route>
          <Route element={<LoginLayout/>}>
            <Route path="/login" element={<AdminLogin/>}/>
          </Route>
          <Route path="/admin" element={<AdminLayout/>}/>
          <Route path="*"      element={<Navigate to="/" replace/>}/>
        </Routes>
      </AppProvider>
    </BrowserRouter>
  );
}
